import React, { useState, useEffect, useRef } from 'react';
import { FaSearch, FaStar, FaPlay, FaDownload, FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import axios from 'axios';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import YouTube from 'react-youtube';
import './App.css';
import MovieSection from './components/MovieSection';

const StreamingApp = () => {
  const [featuredContent, setFeaturedContent] = useState([]);
  const [trendingContent, setTrendingContent] = useState([]);
  const [newReleases, setNewReleases] = useState([]);
  const [topRated, setTopRated] = useState([]);
  const [actionContent, setActionContent] = useState([]);
  const [comedyContent, setComedyContent] = useState([]);
  const [documentaries, setDocumentaries] = useState([]);
  const [bollywoodContent, setBollywoodContent] = useState([]);
  const [southIndianContent, setSouthIndianContent] = useState([]);
  const [downloadableContent, setDownloadableContent] = useState([]);
  const [playableContent, setPlayableContent] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedContent, setSelectedContent] = useState(null);
  const [filter, setFilter] = useState('all');
  const [playingVideoId, setPlayingVideoId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showTrailerModal, setShowTrailerModal] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    fetchData();
  }, [filter]);

  const fetchData = async () => {
    try {
      const apiKey = '619dffdce4dbdde4639132866f8ba2c5';
      const baseUrl = 'https://api.themoviedb.org/3';

      const contentType = filter === 'series' ? 'tv' : 'movie';

      const featuredResponse = await axios.get(`${baseUrl}/${contentType}/popular?api_key=${apiKey}`);
      setFeaturedContent(featuredResponse.data.results.slice(0, 5));

      const trendingResponse = await axios.get(`${baseUrl}/trending/${contentType}/week?api_key=${apiKey}`);
      setTrendingContent(trendingResponse.data.results.slice(0, 50));

      const newReleasesResponse = await axios.get(`${baseUrl}/${contentType}/${contentType === 'movie' ? 'now_playing' : 'on_the_air'}?api_key=${apiKey}`);
      setNewReleases(newReleasesResponse.data.results.slice(0, 50));

      const topRatedResponse = await axios.get(`${baseUrl}/${contentType}/top_rated?api_key=${apiKey}`);
      setTopRated(topRatedResponse.data.results.slice(0, 50));

      const actionResponse = await axios.get(`${baseUrl}/discover/${contentType}?api_key=${apiKey}&with_genres=${contentType === 'movie' ? '28' : '10759'}`);
      setActionContent(actionResponse.data.results.slice(0, 50));

      const comedyResponse = await axios.get(`${baseUrl}/discover/${contentType}?api_key=${apiKey}&with_genres=35`);
      setComedyContent(comedyResponse.data.results.slice(0, 50));

      const documentariesResponse = await axios.get(`${baseUrl}/discover/${contentType}?api_key=${apiKey}&with_genres=${contentType === 'movie' ? '99' : '99,36'}`);
      setDocumentaries(documentariesResponse.data.results.slice(0, 50));

      const bollywoodResponse = await axios.get(`${baseUrl}/discover/${contentType}?api_key=${apiKey}&with_original_language=hi`);
      setBollywoodContent(bollywoodResponse.data.results.slice(0, 50));

      const southIndianResponse = await axios.get(`${baseUrl}/discover/${contentType}?api_key=${apiKey}&with_original_language=ta|te|ml|kn`);
      setSouthIndianContent(southIndianResponse.data.results.slice(0, 50));

      const downloadableResponse = await axios.get(`${baseUrl}/discover/${contentType}?api_key=${apiKey}&sort_by=popularity.desc`);
      setDownloadableContent(downloadableResponse.data.results.slice(0, 50).map(item => ({
        ...item,
        downloadLink: `https://example.com/download/${item.id}`
      })));

      const playableResponse = await axios.get(`${baseUrl}/discover/${contentType}?api_key=${apiKey}&sort_by=popularity.desc`);
      const playableWithVideos = await Promise.all(
        playableResponse.data.results.slice(0, 50).map(async (item) => {
          const videoResponse = await axios.get(`${baseUrl}/${contentType}/${item.id}/videos?api_key=${apiKey}`);
          const youtubeTrailer = videoResponse.data.results.find(video => video.site === 'YouTube' && video.type === 'Trailer');
          return {
            ...item,
            youtubeId: youtubeTrailer ? youtubeTrailer.key : null
          };
        })
      );
      setPlayableContent(playableWithVideos.filter(item => item.youtubeId));
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleSearch = async () => {
    if (searchTerm.trim() === '') {
      setSearchResults([]);
      return;
    }

    try {
      const apiKey = '619dffdce4dbdde4639132866f8ba2c5';
      const baseUrl = 'https://api.themoviedb.org/3';
      const searchResponse = await axios.get(
        `${baseUrl}/search/${filter === 'series' ? 'tv' : 'movie'}?api_key=${apiKey}&query=${encodeURIComponent(searchTerm)}`
      );
      setSearchResults(searchResponse.data.results.filter(item => item.poster_path));
    } catch (error) {
      console.error('Error searching:', error);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      handleSearch();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const handleContentSelect = (content) => {
    setSelectedContent(content);
    setShowModal(true);
  };

 const handlePlayVideo = async (content, event) => {
    event.stopPropagation();
    try {
      const apiKey = '619dffdce4dbdde4639132866f8ba2c5';
      const baseUrl = 'https://api.themoviedb.org/3';
      const contentType = content.first_air_date ? 'tv' : 'movie';
      const videoResponse = await axios.get(`${baseUrl}/${contentType}/${content.id}/videos?api_key=${apiKey}`);
      const youtubeTrailer = videoResponse.data.results.find(video => video.site === 'YouTube' && video.type === 'Trailer');
      if (youtubeTrailer) {
        setPlayingVideoId(youtubeTrailer.key);
        setShowTrailerModal(true);
      } else {
        console.log('No trailer available');
      }
    } catch (error) {
      console.error('Error fetching trailer:', error);
    }
  };

  const handleCloseSearchResults = () => {
    setSearchResults([]);
    setSearchTerm('');
  };

  const ContentCarousel = ({ title, items }) => {
    const carouselRef = useRef(null);

    const scroll = (scrollOffset) => {
      if (carouselRef.current) {
        carouselRef.current.scrollBy({
          left: scrollOffset,
          behavior: 'smooth'
        });
      }
    };

    return (
      <div className="mb-8 relative">
        <h2 className="text-xl md:text-2xl font-bold mb-4 text-white">{title}</h2>
        <div className="relative">
          <button
            className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full z-10 hidden md:block"
            onClick={() => scroll(-200)}
          >
            <FaChevronLeft />
          </button>
          <div
            ref={carouselRef}
            className="flex space-x-4 overflow-x-scroll scrollbar-hide"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {items.map((item) => (
              <div
                key={item.id}
                className="cursor-pointer flex-shrink-0 relative group"
                onClick={() => handleContentSelect(item)}
              >
                <img
                  src={`https://image.tmdb.org/t/p/w500${item.poster_path}`}
                  alt={item.title || item.name}
                  className="w-32 h-48 md:w-40 md:h-60 object-cover rounded-lg shadow-lg transition-transform duration-300 group-hover:opacity-75"
                />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-60 transition-opacity duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
                  <div className="text-white text-center p-2">
                    <h3 className="text-sm md:text-lg font-semibold mb-1 md:mb-2">{item.title || item.name}</h3>
                    <p className="text-xs md:text-sm">{item.release_date || item.first_air_date}</p>
                    <button
                      className="mt-1 md:mt-2 bg-red-600 text-white p-1 md:p-2 rounded-full hover:bg-red-700 transition-colors duration-300"
                      onClick={(e) => handlePlayVideo(item, e)}
                    >
                      <FaPlay className="text-xs md:text-sm" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <button
            className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-full z-10 hidden md:block"
            onClick={() => scroll(200)}
          >
            <FaChevronRight />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <header className="bg-gray-800 py-4 px-6 flex justify-between items-center">
        <h1 className="text-2xl md:text-3xl font-bold">StreamFlix</h1>
        <div className="flex items-center">
          <div className="hidden md:flex items-center">
            <input
              type="text"
              placeholder="Search..."
              className="bg-gray-700 text-white px-4 py-2 rounded-l-full focus:outline-none w-48 md:w-64"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button
              className="bg-red-600 text-white px-4 py-2 rounded-r-full hover:bg-red-700 transition-colors duration-300"
              onClick={handleSearch}
            >
              <FaSearch />
            </button>
          </div>
          <button
            className="md:hidden text-white ml-4"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>
        </div>
      </header>

      {menuOpen && (
        <div className="md:hidden bg-gray-800 p-4">
          <div className="flex items-center mb-4">
            <input
              type="text"
              placeholder="Search..."
              className="bg-gray-700 text-white px-4 py-2 rounded-l-full focus:outline-none flex-grow"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button
              className="bg-red-600 text-white px-4 py-2 rounded-r-full hover:bg-red-700 transition-colors duration-300"
              onClick={handleSearch}
            >
              <FaSearch />
            </button>
          </div>
          <div className="flex flex-col space-y-2">
            <button
              className={`px-4 py-2 rounded-full ${filter === 'all' ? 'bg-red-600' : 'bg-gray-700'} hover:bg-red-700 transition-colors duration-300`}
              onClick={() => {
                setFilter('all');
                setMenuOpen(false);
              }}
            >
              All
            </button>
            <button
              className={`px-4 py-2 rounded-full ${filter === 'movies' ? 'bg-red-600' : 'bg-gray-700'} hover:bg-red-700 transition-colors duration-300`}
              onClick={() => {
                setFilter('movies');
                setMenuOpen(false);
              }}
            >
              Movies
            </button>
            <button
              className={`px-4 py-2 rounded-full ${filter === 'series' ? 'bg-red-600' : 'bg-gray-700'} hover:bg-red-700 transition-colors duration-300`}
              onClick={() => {
                setFilter('series');
                setMenuOpen(false);
              }}
            >
              Series
            </button>
          </div>
        </div>
      )}

      <main className="container mx-auto px-4 py-8">
        {!selectedContent && (
          <>
            {searchResults.length > 0 ? (
              <div className="relative mb-8">
                <ContentCarousel title="Search Results" items={searchResults} />
                <button
                  className="absolute top-0 right-0 bg-red-600 text-white p-2 rounded-full hover:bg-red-700 transition-colors duration-300"
                  onClick={handleCloseSearchResults}
                >
                  <FaTimes />
                </button>
              </div>
            ) : (
              <>
                <Carousel
                  showArrows={true}
                  showStatus={false}
                  showIndicators={true}
                  infiniteLoop={true}
                  autoPlay={true}
                  interval={5000}
                  stopOnHover={false}
                  className="mb-8 rounded-xl overflow-hidden"
                >
                  {featuredContent.map((content) => (
                    <div
                      key={content.id}
                      className="relative h-48 md:h-96 cursor-pointer"
                      onClick={() => handleContentSelect(content)}
                    >
                      <img
                        src={`https://image.tmdb.org/t/p/original${content.backdrop_path}`}
                        alt={content.title || content.name}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent"></div>
                      <div className="absolute bottom-0 left-0 p-4 md:p-8">
                        <h2 className="text-2xl md:text-4xl font-bold mb-1 md:mb-2">{content.title || content.name}</h2>
                        <p className="text-sm md:text-xl mb-2 md:mb-4 line-clamp-2 md:line-clamp-3">{content.overview}</p>
                        <button
                          className="bg-red-600 text-white px-4 py-1 md:px-6 md:py-2 rounded-full hover:bg-red-700 transition-colors duration-300 flex items-center text-sm md:text-base"
                          onClick={(e) => handlePlayVideo(content, e)}
                        >
                          <FaPlay className="mr-1 md:mr-2" /> Play
                        </button>
                      </div>
                    </div>
                  ))}
                </Carousel>
                <div className="mb-8 flex justify-center space-x-4 hidden md:flex">
                  <button
                    className={`px-4 py-2 rounded-full ${filter === 'all' ? 'bg-red-600' : 'bg-gray-700'} hover:bg-red-700 transition-colors duration-300`}
                    onClick={() => setFilter('all')}
                  >
                    All
                  </button>
                  <button
                    className={`px-4 py-2 rounded-full ${filter === 'movies' ? 'bg-red-600' : 'bg-gray-700'} hover:bg-red-700 transition-colors duration-300`}
                    onClick={() => setFilter('movies')}
                  >
                    Movies
                  </button>
                  <button
                    className={`px-4 py-2 rounded-full ${filter === 'series' ? 'bg-red-600' : 'bg-gray-700'} hover:bg-red-700 transition-colors duration-300`}
                    onClick={() => setFilter('series')}
                  >
                    Series
                  </button>
                </div>
                <MovieSection />
                <ContentCarousel title="Trending Now" items={trendingContent} />
                <ContentCarousel title="New Releases" items={newReleases} />
                <ContentCarousel title="Top Rated" items={topRated} />
                <ContentCarousel title={filter === 'series' ? "Action & Adventure" : "Action Movies"} items={actionContent} />
                <ContentCarousel title={filter === 'series' ? "Comedy Series" : "Comedy Movies"} items={comedyContent} />
                <ContentCarousel title="Documentaries" items={documentaries} />
                <ContentCarousel title="Bollywood" items={bollywoodContent} />
                <ContentCarousel title="South Indian" items={southIndianContent} />
                <ContentCarousel title="Downloadable" items={downloadableContent} />
              </>
            )}
          </>
        )}

        {showModal && selectedContent && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="bg-gray-800 rounded-xl p-4 md:p-8 max-w-3xl w-full max-h-full overflow-y-auto">
              <button
                className="mb-4 text-gray-400 hover:text-white transition-colors duration-300"
                onClick={() => {
                  setSelectedContent(null);
                  setShowModal(false);
                }}
              >
                <FaTimes />
              </button>
              <div className="flex flex-col md:flex-row">
                <img
                  src={`https://image.tmdb.org/t/p/w500${selectedContent.poster_path}`}
                  alt={selectedContent.title || selectedContent.name}
                  className="w-full md:w-1/3 rounded-lg shadow-lg mb-4 md:mb-0 md:mr-8"
                />
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold mb-2">
                    {selectedContent.title || selectedContent.name}
                  </h2>
                  <p className="text-gray-400 mb-4">
                    {selectedContent.release_date || selectedContent.first_air_date} |
                    {selectedContent.genre_ids.join(', ')}
                  </p>
                  <p className="text-sm md:text-lg mb-4">{selectedContent.overview}</p>
                  <div className="flex items-center mb-4">
                    <FaStar className="text-yellow-400 mr-1" />
                    <span>{selectedContent.vote_average.toFixed(1)}</span>
                  </div>
                  <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
                    <button
                      className="bg-red-600 text-white px-6 py-2 rounded-full hover:bg-red-700 transition-colors duration-300 flex items-center justify-center"
                      onClick={(e) => handlePlayVideo(selectedContent, e)}
                    >
                      <FaPlay className="mr-2" /> Play
                    </button>
                    {/* Always display Download button and redirect to Telegram */}
                    <a
                      href="https://t.me/EmberTheBot"  
                      className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition-colors duration-300 flex items-center justify-center"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaDownload className="mr-2" /> Download
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}


        {showTrailerModal && playingVideoId && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
            <div className="bg-gray-800 rounded-xl p-4 md:p-8 max-w-4xl w-full">
              <button
                className="mb-4 text-gray-400 hover:text-white transition-colors duration-300"
                onClick={() => {
                  setPlayingVideoId(null);
                  setShowTrailerModal(false);
                }}
              >
                <FaTimes />
              </button>
              <div className="aspect-w-16 aspect-h-9">
                <YouTube
                  videoId={playingVideoId}
                  opts={{
                    width: '100%',
                    height: '100%',
                    playerVars: {
                      autoplay: 1,
                    },
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </main>

      <footer className="bg-gray-800 py-4 px-6 text-center">
        <p>© 2023 StreamFlix. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default StreamingApp;
